import React from 'react';
import PropTypes from "prop-types";
import {connect} from 'react-redux';
import webservice from '../common/Webservice';
import {AjaxSpinner, ColumnInformation, ConfirmationButton, PopupWindow, SelectInput, Size, Table, TableSorter, TableSorterField, TableSorterInformation, TextArea} from "@utahdts/dts-react-common";
import Button from "@utahdts/dts-react-common/components/form/button/Button";
import FilterType from "@utahdts/dts-react-common/components/table/FilterType";
import {capitalize, COBI_ROLES, dispatchUpdateData, isApprover, TABS_STRUCTURE} from "../misc/Shared";
import {checkCircle, checkCloud} from "../common/Icon";
import {cookies, createCookie, eraseCookie, readCookie, verifyCookie} from "../misc/Cookies";
import {isNull} from "lodash";

const propTypes = {
    currentCobiId: PropTypes.number,

    currentTab: PropTypes.string,

    currentYear: PropTypes.number,

    draft: PropTypes.bool,

	history: PropTypes.object.isRequired,

	userAccount: PropTypes.object.isRequired
};

const defaultProps = {};

const mapStateToProps = state => ({
    currentCobiId: state.app.currentCobiId,
    currentTab: state.app.currentTab,
    currentYear: state.app.currentYear,
    draft: state.app.draft,
	userAccount: state.userAccount
});

class List extends React.Component {
    constructor(props) {
        super(props);

		this.state = {
			agencies: [],
			busy: true,
			content: undefined,
			filteredTableData: [],
			filterId: undefined,
			fiscalYears: [],
			fullTableData: [],
			lineItems: [],
			menu: undefined,
			selectedAgency: readCookie(cookies.selectedAgency) ? Number(readCookie(cookies.selectedAgency)) : undefined,
			selectedFiscalYear: readCookie(cookies.selectedFiscalYear) ? Number(readCookie(cookies.selectedFiscalYear)) : this.props.currentYear,
			selectedLineItem: readCookie(cookies.selectedLineItem) ? Number(readCookie(cookies.selectedLineItem)) : undefined,
			selectedSubCommittee: readCookie(cookies.selectedSubCommittee) ? Number(readCookie(cookies.selectedSubCommittee)) : undefined,
			selectedList: [],
			sendBack: false,
			showFilteredTableData: false,
			subCommittees: [],
			tableData: [],
			tableIsReady: false,
			showMessage: false,
			message: '',
			reason: '',
		};

		!readCookie(cookies.selectedFiscalYear) && createCookie(cookies.selectedFiscalYear, this.props.currentYear, 30);

        this.setFilteredTable = this.setFilteredTable.bind(this);
        this.setMenu = this.setMenu.bind(this);
        this.setFilterId = this.setFilterId.bind(this);
        this.getContent = this.getContent.bind(this);
        this.getMenu = this.getMenu.bind(this);
        this.getFilterSet = this.getFilterSet.bind(this);
        this.updateCookieFilter = this.updateCookieFilter.bind(this);
		this.rowClicked = this.rowClicked.bind(this);
		this.displayMessage = this.displayMessage.bind(this);
		this.hideMessage = this.hideMessage.bind(this);
		this.submitAll = this.submitAll.bind(this);
		this.refreshContent = this.refreshContent.bind(this);
		this.approveAll = this.approveAll.bind(this);
		this.sendAllBack = this.sendAllBack.bind(this);
        this.getMenu();

        const sortLocation = new TableSorterField('locationPath', TableSorter.SORT.TEXT, TableSorter.DIRECTION.ASCENDING);
        const sortTab = new TableSorterField('tab', TableSorter.SORT.TEXT, TableSorter.DIRECTION.ASCENDING);
        const sortAnalyst = new TableSorterField('analyst', TableSorter.SORT.TEXT, TableSorter.DIRECTION.ASCENDING);
        const sortSupervisor = new TableSorterField('supervisor', TableSorter.SORT.TEXT, TableSorter.DIRECTION.ASCENDING);
        const sortStatus = new TableSorterField('status', TableSorter.SORT.TEXT, TableSorter.DIRECTION.ASCENDING);
        // const sortBillYear = new TableSorterField('billYear', TableSorter.SORT.NUMBER, TableSorter.DIRECTION.ASCENDING);

		const analystDefault = this.props.userAccount.roleName === COBI_ROLES.ANALYST ? [this.props.userAccount.analystLogin] : undefined;
		const supervisorDefault = this.props.userAccount.roleName === COBI_ROLES.SUPERVISOR ? [this.props.userAccount.supervisorLogin] : undefined;
		const statusDefault = this.props.userAccount.roleName === COBI_ROLES.ANALYST ? ['rework', 'editing'] : this.props.userAccount.roleName === COBI_ROLES.SUPERVISOR ? ['submitted', 'editing'] : undefined;

        this.columns = [
            new ColumnInformation({
                title: 'Location',
                field: 'locationPath',
                tableSorterInformation: new TableSorterInformation([sortLocation]),
                tdCallback: (columnInfo, objectData) => (
                    <td key={columnInfo.field ? columnInfo.field : columnInfo.key}>{this.renderLocation(objectData.locationPath)}</td>),
				filterCallback: (list, value) => this.updateCookieFilter([{value: value, name: 'locationPath'}])
            }),
            new ColumnInformation({
                title: 'Tab',
                field: 'tab',
                tableSorterInformation: new TableSorterInformation([sortTab]),
                tdCallback: (columnInfo, objectData) => (
                    <td key={columnInfo.field ? columnInfo.field : columnInfo.key}>{objectData.tab}</td>),
				filterType: FilterType.SELECT_MULTI,
				filterCallback: (list, value) => this.updateCookieFilter([{value: value, name: 'tab'}])
            }),
            new ColumnInformation({
                title: 'Analyst',
                field: 'analyst',
                tableSorterInformation: new TableSorterInformation([sortAnalyst]),
                tdCallback: (columnInfo, objectData) => (
                    <td key={columnInfo.field ? columnInfo.field : columnInfo.key}>{objectData.analyst}</td>),
				filterType: FilterType.SELECT_MULTI,
				filterTypeOptions: [],
				filterDefaultValue: analystDefault,
				filterCallback: (list, value) => this.updateCookieFilter([{value: value, name: 'analyst'}])
            }),
            new ColumnInformation({
                title: 'Supervisor',
                field: 'supervisor',
                tableSorterInformation: new TableSorterInformation([sortSupervisor]),
                tdCallback: (columnInfo, objectData) => (
                    <td key={columnInfo.field ? columnInfo.field : columnInfo.key}>{objectData.supervisor}</td>),
				filterType: FilterType.SELECT_MULTI,
				filterTypeOptions: [],
				filterDefaultValue: supervisorDefault,
				filterCallback: (list, value) => this.updateCookieFilter([{value: value, name: 'supervisor'}])
			}),
            new ColumnInformation({
                title: 'Status',
                field: 'status',
                tableSorterInformation: new TableSorterInformation([sortStatus]),
                tdCallback: (columnInfo, objectData) => (
					<td key={columnInfo.field ? columnInfo.field : columnInfo.key}>
						{this.renderStatus(objectData.status)}
						{objectData.isAutoApproved ? checkCloud('active right10') : ''}
					</td>),
				filterType: FilterType.SELECT_MULTI,
				filterTypeOptions: [],
				filterDefaultValue: statusDefault,
				filterCallback: (list, value) => this.updateCookieFilter([{value: value, name: 'status'}])
            }),
			new ColumnInformation({
				title: 'Active',
				field: 'isActive',
				filterType: FilterType.SELECT,
				filterTypeOptions: [],
				tdCallback: (columnInfo, objectData) => (
					<td key={columnInfo.field ? columnInfo.field : columnInfo.key} >{objectData.isActive ? checkCircle('active') : checkCircle('inactive')}</td>),
				filterCallback: (list, value) => this.updateCookieFilter([{value: value, name: 'isActive'}])
			})
        ];

		this.timer = undefined;
    }

    componentDidMount() {
		dispatchUpdateData([
			{path: 'app', field: 'currentPageTitle', value: 'Changes in COBI'},
		]);

    	let promises = [];
		let year = this.state.selectedFiscalYear === undefined ? this.props.currentYear : this.state.selectedFiscalYear;

		promises.push(webservice.public.list.fiscalYears().then(data => this.setState({fiscalYears: data})));
		promises.push(webservice.public.list.get(year).then(data => this.setState({tableData: data})));

		const tabOptions = Object.keys(TABS_STRUCTURE).map(tab => {
			return {label: capitalize(TABS_STRUCTURE[tab]), value: capitalize(TABS_STRUCTURE[tab])};
		});
		const activeOptions = [{label: 'Active', value: 'true'},{label: 'Inactive', value: 'false'}];

		this.columns[0].filterDefaultValue = readCookie(cookies.locationPath);
		this.columns[1].filterTypeOptions = tabOptions;
		this.columns[1].filterDefaultValue = this.getDefaultFilter('tab', tabOptions);

		promises.push(webservice.admin.datalist.analysts().then(data => {
			this.columns[2].filterTypeOptions = data;
			this.columns[2].filterDefaultValue = this.getDefaultFilter('analyst', data);
		}));
		promises.push(webservice.admin.datalist.supervisors().then(data => {
			this.columns[3].filterTypeOptions = data;
			this.columns[3].filterDefaultValue = this.getDefaultFilter('supervisor', data);
		}));
		promises.push(webservice.admin.datalist.statuses().then(data => {
			this.columns[4].filterTypeOptions = data;
			this.columns[4].filterDefaultValue = this.getDefaultFilter('status', data);
		}));

		this.columns[5].filterTypeOptions = activeOptions;
		this.columns[5].filterDefaultValue =  this.getDefaultFilter('isActive', activeOptions);

		Promise.all(promises).then(() => this.setState({tableIsReady: true}, this.setFilterId));
	}

    componentWillUnmount() {
        this.isCancelled = true;
    }

    updateCookieFilter(filters) {
		filters.forEach(filter => !isNull(filter.value) ? createCookie(filter.name, filter.value, 30) : eraseCookie(filter.name));
	}

	getDefaultFilter(name, data) {
		return readCookie(name) ? verifyCookie(name, data) : [];
	}

    getContent() {
        let year = this.state.selectedFiscalYear === undefined ? this.props.currentYear : this.state.selectedFiscalYear;
        webservice.public.list.fiscalYears().then(data => this.setState({fiscalYears: data}));
        webservice.public.list.get(year).then(data => this.setState({tableData: data, showFilteredTableData: !!readCookie(cookies.selectedSubCommittee), busy: false,  selectedList: []}));
        this.getMenu();
    }

    getMenu() {
        let year = this.state.selectedFiscalYear === undefined ? this.props.currentYear : this.state.selectedFiscalYear;

        let cobiId = null;
        if (this.state.selectedAgency) {
            cobiId = this.state.selectedAgency;
        } else if (this.state.selectedSubCommittee) {
            cobiId = this.state.selectedSubCommittee;
        } else {
            cobiId = 1;
        }

        webservice.public.list.menuById(cobiId, year).then(this.setMenu);
    }

    getFilterSet() {
		let year = this.state.selectedFiscalYear === undefined ? this.props.currentYear : this.state.selectedFiscalYear;
		this.setState({busy: true}, () => setTimeout(() => webservice.public.list.filter(year, this.state.filterId).then(this.setFilteredTable), 500));
    }

    setMenu(data) {
        let subCommitteesArray = selectIt(data.subCommittee);
        let agencyArray = selectIt(data.agency);
        let lineItemsArray = selectIt(data.lineItem);

        !this.isCancelled && this.setState({
            menu: data
            , subCommittees: subCommitteesArray
            , agencies: agencyArray
            , lineItems: lineItemsArray
        });
    }

    setFilteredTable(data) {
        let filteredArray = this.state.tableData.filter(function(itm){
            return data.indexOf(itm.cobiId) > -1;
        });

        !this.isCancelled && this.setState({filteredTableData: filteredArray, showFilteredTableData: true, busy: false, selectedList: []});
    }

    setFilterId() {
        if (this.state.selectedLineItem) {
            !this.isCancelled && this.setState({filterId: this.state.selectedLineItem}, this.getFilterSet);
        } else if (this.state.selectedAgency) {
            !this.isCancelled && this.setState({filterId: this.state.selectedAgency}, this.getFilterSet);
        } else if (this.state.selectedSubCommittee) {
            !this.isCancelled && this.setState({filterId: this.state.selectedSubCommittee}, this.getFilterSet);
        } else {
            !this.isCancelled && this.setState({showFilteredTableData: false, busy: false});
        }
    }

    renderLocation(path) {
    	const locations = path.split('.');
		return locations.map((location, index) => location + (index < locations.length - 1 ? ' » ' : ''));
	}

	rowClicked(record) {
		let selectedList = this.state.selectedList.concat([]);
		if (selectedList.includes(record)) {
			selectedList = selectedList.filter(selected => selected !== record);
		} else {
			selectedList.push(record);
		}
		this.setState({selectedList: selectedList});
	}

	displayMessage(message) {
		if (this.timer) {
			clearTimeout(this.timer);
			this.timer = undefined;
		}
		this.setState({
			showMessage: true,
			message: message
		}, () => this.timer = setTimeout(this.hideMessage, 2000));
	}

	hideMessage() {
		this.setState({showMessage: false});
		clearTimeout(this.timer);
		this.timer = undefined;
	}

	refreshContent() {
		let promises = [];
		let year = this.state.selectedFiscalYear === undefined ? this.props.currentYear : this.state.selectedFiscalYear;
		promises.push(webservice.public.list.fiscalYears().then(data => this.setState({fiscalYears: data})));
		promises.push(webservice.public.list.get(year).then(data => this.setState({tableData: data})));
		Promise.all(promises).then(() => this.setState({busy: false,  selectedList: []}, this.setFilterId));
	}

	submitAll() {
		let promises = [];
    	this.setState({busy: true}, () => {
    		this.state.selectedList.forEach(tab => promises.push(webservice.admin.tab.submit(tab.tab, this.state.selectedFiscalYear, tab.cobiId)));
    		Promise.all(promises).then(() => {
				this.displayMessage('All tabs have been submitted.');
				this.refreshContent();
			}).catch(() => {
				this.setState({busy: false});
				this.displayMessage('One or more tabs could not be submitted.');
			});
		});
	}

	approveAll() {
    	let promises = [];
    	this.setState({busy:  true}, () => {
    		this.state.selectedList.forEach(tab => promises.push(webservice.admin.tab.approve(tab.tab, this.state.selectedFiscalYear, tab.cobiId)));
    		Promise.all(promises).then(() => {
    			this.displayMessage('All tabs have been approved.');
				this.refreshContent();
			}).catch(() => {
				this.setState({busy: false});
				this.displayMessage('One or more tabs could not be submitted.');
			});
		});
	}

	sendAllBack() {
    	let promises = [];
    	this.setState({busy:false, sendBack: false}, () => {
    		this.state.selectedList.forEach(tab => promises.push(webservice.admin.comment.post({
				"comment": this.state.reason,
				"cobiId": tab.cobiId,
				"tabName": tab.tab,
				"sessionFiscalYear": this.state.selectedFiscalYear,
			}).then(() => webservice.admin.tab.revise(tab.tab, this.state.selectedFiscalYear, tab.cobiId))));
    		Promise.all(promises).then(()  => {
				this.displayMessage('All tabs have been sent back.');
				this.setState({reason: ''});
				this.refreshContent();
			}).catch(() => {
				this.setState({busy: false});
				this.displayMessage('One or more tabs could not be submitted.');
			});
		});
	}

    render() {
        return (
            <section className="section-content flex1">
				{this.state.busy && <AjaxSpinner backdropType={AjaxSpinner.BACKDROPS.COVER_PAGE}/>}
				{this.state.showMessage && <div className="no-backdrop">
					<PopupWindow onBackdropCallback={this.hideMessage}>
						{this.state.message}
					</PopupWindow>
				</div>}
				{this.state.sendBack && <PopupWindow
					footerChildren={<React.Fragment>
						<Button label="Cancel"
								onClick={() => this.setState({sendBack: false})}
								className="grey"/>
						<Button label="Send back"
								onClick={this.sendAllBack}
								className="blue"
								disabled={!/\S/.test(this.state.reason)}/>
					</React.Fragment>}>
					<TextArea field="reason"
							  label="Please enter reason for sending back:"
							  size={Size.FULL_WIDTH}
							  placeholder="Type your comment here..."
							  value={this.state.reason}
							  onChange={(field, value) => this.setState({[field]: value})}/>
				</PopupWindow>}
				<div className="content">
                    <div className="inline-block">
                        <div className="flex align-end direction-col">
                            <SelectInput
                                field="fiscalYear"
                                label="FY:"
                                allowClear={false}
                                showSearch={false}
                                className="mr-spacing full-mobile normal-font"
                                options={this.state.fiscalYears}
                                value={this.state.selectedFiscalYear}
								onChange={(field, val) => {
									this.updateCookieFilter([
										{value: val, name: cookies.selectedFiscalYear},
										{value: null, name: cookies.selectedSubCommittee},
										{value: null, name: cookies.selectedAgency},
										{value: null, name: cookies.selectedLineItem}
									]);
									this.setState({
										selectedFiscalYear: val,
										selectedSubCommittee: null,
										selectedAgency: null,
										selectedLineItem: null,
										showFilteredTableData: false,
										busy: true,
										selectedList: [],
									}, this.getContent);
								}}
								size={Size.XLARGE}
                            />
                            <SelectInput
                                field="subcommittee"
                                label="Subcommittee:"
                                allowClear={true}
                                showSearch={false}
                                className="mr-spacing full-mobile normal-font"
                                options={this.state.subCommittees}
                                value={this.state.selectedSubCommittee}
								onChange={(field, val) => {
									this.updateCookieFilter([
										{value: val, name: cookies.selectedSubCommittee},
										{value: null, name: cookies.selectedAgency},
										{value: null, name: cookies.selectedLineItem}
									]);
									this.setState({
										selectedSubCommittee: val,
										selectedAgency: null,
										selectedLineItem: null
									}, this.getMenu);
								}}
								size={Size.XLARGE}
                            />
                            <SelectInput
                                field="agency"
                                label="Agency:"
                                allowClear={true}
                                showSearch={false}
                                className="mr-spacing full-mobile normal-font"
                                options={this.state.agencies}
                                value={this.state.selectedAgency}
								onChange={(field, val) => {
									this.updateCookieFilter([
										{value: val, name: cookies.selectedAgency},
										{value: null, name: cookies.selectedLineItem}
									]);
									this.setState({
										selectedAgency: val,
										selectedLineItem: null
									}, this.getMenu);
								}}
								size={Size.XLARGE}
                            />
                            <SelectInput
                                field="lineItem"
                                label="Line Item:"
                                allowClear={true}
                                showSearch={false}
                                className="mr-spacing full-mobile normal-font"
                                options={this.state.lineItems}
                                value={this.state.selectedLineItem}
								onChange={(field, val) => {
									this.updateCookieFilter([{value: val, name: cookies.selectedLineItem}]);
									this.setState({
										selectedLineItem: val
									});
								}}
								size={Size.XLARGE}
                            />
                            <Button label="Filter" onClick={this.setFilterId} className="mr-spacing"/>
                        </div>
                    </div>
					{this.state.tableIsReady && <div>
						<section className="mt-spacing-large gray-box publish-box max-width-none float-left">
							<h2>Mass publish</h2>
							<div className="flex flex-wrap publish-box--content">
								<Button onClick={() => this.setState({selectedList: []})} disabled={this.state.selectedList.length <= 0} label="Reset all" addWrapper={true} className="mr-spacing"/>
								<ConfirmationButton onConfirm={this.submitAll} disabled={this.state.selectedList.length <= 0}
													initialLabel="Submit all" promptLabel="Are you sure?"
													addWrapper={true} className="blue mr-spacing"/>
								{isApprover() && <ConfirmationButton onConfirm={() => this.setState({sendBack: true})} disabled={this.state.selectedList.length <= 0}
																	 initialLabel="Send all back" promptLabel="Are you sure?"
																	 addWrapper={true} className="orange mr-spacing"/>}
								{isApprover() && <ConfirmationButton onConfirm={this.approveAll} disabled={this.state.selectedList.length <= 0}
																	 initialLabel="Approve all" promptLabel="Are you sure?"
																	 addWrapper={true} className="primary"/>}
							</div>
						</section>
						<Table
							columns={this.columns}
							list={this.state.showFilteredTableData ? this.state.filteredTableData : this.state.tableData}
							defaultSortField={'locationPath'}
							selectedList={this.state.selectedList}
							onRowClick={(record, e) => e.target.parentElement.tagName === 'TR' && this.rowClicked(record)}
							onRowDoubleClick={data => this.props.history.push('/admin/editor/' + this.state.selectedFiscalYear + '/' + data.cobiId + '/' + data.tab.toLowerCase())}
							filters={true}
							className="list-changes"
							showLimit={50}
							pagination={true}
						/>
					</div>}
                </div>
            </section>
        );
    }

	renderStatus(status) {
		const newStatus = status === 'public' ? 'Approved'
			: status === 'editing' ? 'Draft'
			: capitalize(status);
		return newStatus;
	}
}

function selectIt(data) {
    let array = [];

    if (data) {
        data.forEach((c) => {
            array.push({value: c.cobiId, label: c.orgName});
        });
    }

    return array;
}

List.propTypes = propTypes;
List.defaultProps = defaultProps;

export default connect(mapStateToProps)(List);
